import { FC } from 'react'
import { Skeleton } from 'src/components/Skeleton'
import classes from './competitorCard.module.scss'

// All dimensions below come from competitorCard.module.scss so the placeholder
// occupies the loaded card's footprint exactly:
//   .logo 48x48 radius 10 · .name font-size 16 · .adsCount line-height 36
//   .sectionLabel font-size 13 · .platformBadge*/.countryChip height 26 radius 20
//   .viewBtn height 40 radius 30 · .timestamps font-size 12
const LOGO_SIZE = 48
const LOGO_RADIUS = 10
const NAME_HEIGHT = 16
const ADS_COUNT_HEIGHT = 36
const ADS_COUNT_WIDTH = 48
const LABEL_HEIGHT = 13
const CHIP_HEIGHT = 26
const CHIP_RADIUS = 20
const VIEW_BTN_HEIGHT = 40
const VIEW_BTN_RADIUS = 30
const TIMESTAMP_HEIGHT = 12

export const CompetitorCardSkeleton: FC = () => (
  <div className={classes.card}>
    <div className={classes.header}>
      <Skeleton height={LOGO_SIZE} radius={LOGO_RADIUS} width={LOGO_SIZE} />
      <div className={classes.headerInfo}>
        <Skeleton height={NAME_HEIGHT} width="60%" />
      </div>
    </div>

    <div className={classes.divider} />

    <div className={classes.body}>
      <div className={classes.adsSection}>
        <Skeleton height={ADS_COUNT_HEIGHT} width={ADS_COUNT_WIDTH} />
        <div className={classes.adsBottom}>
          <Skeleton height={LABEL_HEIGHT} width={72} />
        </div>
      </div>

      <div className={classes.infoSection}>
        <div className={classes.platformsSection}>
          <Skeleton height={LABEL_HEIGHT} width={62} />
          <div className={classes.platformsList}>
            <Skeleton height={CHIP_HEIGHT} radius={CHIP_RADIUS} width={84} />
            <Skeleton height={CHIP_HEIGHT} radius={CHIP_RADIUS} width={84} />
          </div>
        </div>

        <div className={classes.countriesSection}>
          <Skeleton height={LABEL_HEIGHT} width={100} />
          <div className={classes.countriesList}>
            <Skeleton height={CHIP_HEIGHT} radius={CHIP_RADIUS} width={72} />
            <Skeleton height={CHIP_HEIGHT} radius={CHIP_RADIUS} width={88} />
            <Skeleton height={CHIP_HEIGHT} radius={CHIP_RADIUS} width={64} />
          </div>
        </div>
      </div>
    </div>

    <div className={classes.footer}>
      <div className={classes.timestamps}>
        <Skeleton height={TIMESTAMP_HEIGHT} width={180} />
      </div>
      <Skeleton height={VIEW_BTN_HEIGHT} radius={VIEW_BTN_RADIUS} />
    </div>
  </div>
)
